import { create } from "zustand";
import { persist } from "zustand/middleware";
import AudioManager from "../utils/AudioManager";

const webStorage = {
  getItem: (name) => Promise.resolve(localStorage.getItem(name)),
  setItem: (name, value) => Promise.resolve(localStorage.setItem(name, value)),
  removeItem: (name) => Promise.resolve(localStorage.removeItem(name)),
};

export const useSoundsStore = create(
  persist(
    (set, get) => ({
      sfxVolume: 0.05,
      musicVolume: 0.05,
      isMusicMuted: false,
      isSfxMuted: false,
      soundBank: {},
      sfxBank: {},
      musicBank: {},
      soundsReady: false,
      musicReady: false,

      setSoundBank: (newBank) =>
        set({ soundBank: newBank, sfxBank: newBank, soundsReady: true }),
      setSfxBankAndReady: (keys) =>
        set({ soundBank: keys, sfxBank: keys, soundsReady: true }),
      setMusicBankAndReady: (newMusicBank) =>
        set({ musicBank: newMusicBank, musicReady: true }),
      setMusicScreenUrls: (screenKey, urls) =>
        set((state) => ({
          musicBank: {
            ...state.musicBank,
            [screenKey]: urls,
          },
          musicReady: true,
        })),

      setSfxVolume: (value) => set({ sfxVolume: value }),

      setMusicVolume: (volume) => {
        set({ musicVolume: volume });
        if (!get().isMusicMuted && AudioManager.setMusicVolume) {
          AudioManager.setMusicVolume(volume);
        }
      },

      toggleMusicMute: () => {
        set((state) => {
          const nowMuted = !state.isMusicMuted;
          if (nowMuted) {
            AudioManager.stopMusic?.();
          } else {
            AudioManager.setMusicVolume?.(state.musicVolume);
          }
          return { isMusicMuted: nowMuted };
        });
      },
      toggleSfxMute: () => set((state) => ({ isSfxMuted: !state.isSfxMuted })),
    }),
    {
      name: "sounds-storage",
      storage: webStorage,
      partialize: (state) => ({
        sfxVolume: state.sfxVolume,
        musicVolume: state.musicVolume,
        isMusicMuted: state.isMusicMuted,
        isSfxMuted: state.isSfxMuted,
      }),
    }
  )
);
